import styled from 'styled-components';

const Wrapper = styled.span`
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    color: #FFFFFF;
    margin-bottom: 20px;
    width: calc(100% - 40px);
`;

export default Wrapper;